/**
 * File woocommerce.js.
 *
 * Settings for Woocommerce
 *
 */
(function ($) {
	$(function () {
		
		// Listen for changes on radio buttons within the container
		$('.wcd-woocommerce-variation-buttons input[type="radio"]').on('change', function () {
			// Remove 'checked' class from all labels within the container
			$('.wcd-woocommerce-variation-buttons label').removeClass('checked');

			// Add 'checked' class to the label corresponding to the checked radio
			$('label[for="' + $(this).attr('id') + '"]').addClass('checked');

			// Sync the change to the corresponding select element if needed
			const radioName = $(this).attr('name');
			const radioValue = $(this).val();
			$('select[name="' + radioName + '"]').val(radioValue).trigger('change');

			// Parse the variations JSON from the form data-attribute
			var variations = JSON.parse($('.variations_form').attr('data-product_variations'));

			// Find the matching variation
			var matchedVariation = variations.find(variation => variation.attributes['attribute_size'] === radioValue);
		});
	});

	var modal = document.getElementById("shippingModal");
	var btn = document.querySelector(".free-shipping-button");
	var span = document.getElementsByClassName("close")[0];
	if (btn) {

		btn.onclick = function () {
			modal.classList.add("show");
		}

		span.onclick = function () {
			modal.classList.remove("show");
		}

		window.onclick = function (event) {
			if (event.target == modal) {
				modal.classList.remove("show");
			}
		}
	}


})(jQuery);
